<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped></style>
<script>
import AkHeader from '@/components/AkHeader.vue';
import AkFooter from '@/components/AkFooter.vue';
export default {
    components: {
        AkHeader,
        AkFooter
    }
};
</script>
